const backgroundColors = {
	transparent: 'rgba(255,255,255,0)',
	white: 'white',
	greyWithWhite: '#D6D6D6',
	greyWithBlack: '#D6D6D7',
	dark: '#231F1F',
	//lightBlue: '#71C5E8',
	// yellow: '#FFCD04',
	// orange: '#FAA224',
	// green: '#BED730',
	// blue: '#233570',
};

const colorClassNames = {
	'rgba(255,255,255,0)': 'transparent',
	white: 'white',
	'#D6D6D6': 'greyWithWhite',
	'#D6D6D7': 'greyWithBlack',
	'#231F1F': 'dark',
	'#71C5E8': 'lightBlue',
	'#BED730': 'green',
	'#233570': 'blue',
	'#FFCD04': 'yellow',
	'#FAA224': 'orange',
};

const textColorsForBackground = {
	transparent: 'black',
	white: 'black',
	green: 'white',
	blue: 'white',
	lightBlue: 'white',
	greyWithWhite: 'white',
	greyWithBlack: 'black',
	dark: 'white',
	yellow: 'white',
	orange: 'white',
};

export {
	backgroundColors,
	colorClassNames,
	textColorsForBackground
}
